import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import messages from './messages';
import { getBrandName } from '../../Base/i18n/brand';
import { HEAD_FAVICON } from './headLinks';

const Head = () => {
  const intl = useIntl();
  const favicon = HEAD_FAVICON['pt-BR'];

  return (
    <Helmet>
      <html lang={intl.locale} translate="no" />
      <title>
        {intl.formatMessage(messages.title, { companyName: getBrandName() })}
      </title>
      <meta
        name="apple-mobile-web-app-title"
        content={intl.formatMessage(messages.title)}
      />
      <meta name="google" content="notranslate" />
      <link {...favicon} />
    </Helmet>
  );
};

export default Head;
